import React from 'react'
import Navbody from '../props/main-pages/Navbody'

function DesignServices() {
  return (
    <div>
            <Navbody video="/videos/design_services.mp4" text="Design Services" subText="your constructive partner" threeText="We're pioneers in" fourText="providing mep engineering services with " fivetext="professionalism, honesty and value" button1='Learn More +' button2='Get a Quote +' mainTextClassName="2xl:text-9xl xl:text-[134px] 2xl:ml-16 xl:mt-3 xl:ml-16 lg:ml-16 2xl:mb-4 xl:mb-4 tracking-wide" />

    </div>
  )
}

export default DesignServices